// /**
//  * @author krisjczhang
//  * @email krisjczhang@tencent.com
//  * @create date 2020-03-30 15:59:05
//  * @modify date 2020-03-30 15:59:05
//  * @desc [维保管理接口]]
//  */

import { formatApi } from '../baseApi';
import { Message } from 'element-ui';
// import store from './store';

// 新打开的工单页面接口
export async function ticketIdData(params) {
  try {
    const result = await formatApi({
      Action: 'Ticket',
      Method: 'Create',
      SystemId: '2',
      // Data: params,
      Data: {
        ProcessDefinitionKey: 'wb_test3',
        TicketTitle: '维保需求申请工单',
        TicketDescription: '维保需求申请工单',
        TicketLevel: 1,
        UserInfo: {
          // Creator: "v_peiqxiong",
          Creator: store.state.user.name,
          Concern: 'hankyuan',
        },
      },
    });

    console.log(result, 'jjj');
    return result;
  } catch (error) {
  }
}

// 获取区域与园区下拉框数据
export async function getParkList(params) {
  try {
    const result = await formatApi({
      Action: 'QueryData',
      Method: 'Run',
      SystemId: '2',
      SchemaId: 'wb_demand_region',
      ReturnTotalRows: 1,
      Data: params,
    });

    console.log(result.data, 'ccc');
    return result.data;
  } catch (error) {
  }
}

// 需求审批管理列表数据
export async function getApprovalList(params) {
  try {
    const result = await formatApi({
      Action: 'QueryData',
      Method: 'Run',
      SystemId: '2',
      SchemaId: 'wb_demand',
      ReturnTotalRows: 1,
      Data: params,
    });

    return result.data;
  } catch (error) {
  }
}

// 维保合同管理列表数据
export async function getContractList(params) {
  try {
    const result = await formatApi({
      Action: 'QueryData',
      Method: 'Run',
      SystemId: '2',
      SchemaId: 'wb_contract',
      ReturnTotalRows: 1,
      Data: params,
    });

    return result.data;
  } catch (error) {
  }
}

// 维保服务商季度评价管理列表数据
export async function getServiceList(params) {
  try {
    const result = await formatApi({
      Action: 'QueryData',
      Method: 'Run',
      SystemId: '2',
      SchemaId: 'wb_supplier_comment',
      ReturnTotalRows: 1,
      Data: params,
    });

    console.log(result, 'vvv');
    return result.data;
  } catch (error) {
  }
}

// 维保设施管理地区选择框
export async function aaa(params) {
  try {
    const result = await formatApi({
      Action: 'Idcdb',
      Method: 'Query',
      SystemId: '2',
      table: 'mozu',
      // Data: params,
      fields: [
        'mozu_name',
      ],
      conditions: [{
        name: 'campus_name',
        value: ['贵阳-贵安七星'],
      }],
      start: 0,
      limit: 10,
    });

    return result.data;
  } catch (error) {
  }
}

// 维护方带出服务商数据
export async function GetSupplierList() {
  try {
    const result = await formatApi({
      Action: 'WB',
      Method: 'GetSupplierList',
      SystemId: '2',
    });

    console.log(result.data, '维护方带出服务商数据');
    return result.data;
  } catch (error) { }
}

// 通过服务商和职位信息筛选接单人
export async function getDealer(AccountType, DeptId, Campus) {
  try {
    const result = await formatApi({
      Action: 'WB',
      Method: 'GetSupplierManager',
      SystemId: '2',
      DeptId,
      AccountType,
      Campus,
    });

    return result.data;
  } catch (error) {
  }
}

